import { motion } from 'framer-motion';
import HomePageLoader from '../../Components/Loaders/HomePageLoader';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import useGetHomePageProducts from '../../hooks/use-get-home-page.js';
import useGetVehicleCards from '../../hooks/use-get-vehicle-cards.js';
import AdCardPage from './AdCard.js';
import VehicleCard from './VehicleCard.js';
import TrendingCard from './TrendingCard.js';
import TileCard from './TileCard.js';

const HomePage = () => {
    const { data: homeCards, isLoading } = useGetHomePageProducts();

    const { data: vehicleCards } = useGetVehicleCards();
    return (
        <motion.div className="relative w-full flex min-h-screen flex-row justify-center">
            {isLoading ? (
                <HomePageLoader />
            ) : (
                <motion.div className="flex gap-10 min-h-screen relative bg-gray-50 flex-col w-full">
                    <AdCardPage />
                    <VehicleCard vehicleCards={vehicleCards} />
                    <TileCard homeCards={homeCards?.homePage1} />
                    <TrendingCard
                        trendingCards={homeCards?.trending && homeCards?.trending[0]?.products}
                        title={homeCards?.trending && homeCards?.trending[0]?.title}
                    />
                </motion.div>
            )}
        </motion.div>
    );
};

export default HomePage;
